let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hzdFQ")).then(() => parcelRequire('dKu0d'));